export default [
  {
    path: '/v2/student-transfers/create',
    name: 'transfer-create',
    meta: { requiresAuth: true },
    component: () => import('./views/create.vue')
  }
]
